export const allowedCssProperties = [
    'background-color',
    'color',
    'font-style',
    'font-weight',
    'text-decoration-color',
    'text-decoration-line',
    'text-decoration-skip-ink',
    'text-decoration-style',
    'text-decoration-thickness',
    'text-decoration',
    'width',
    'height',
    'min-width',
    'min-height',
];
